import React from "react";
import Select from "react-select";

const CustomSelect = ({ value, onChange, options, className, editingEvent, editingOptions = [] }) => {

  
  const defaultValue = (options, value) => {
    return options ? options.find((option) => option.value === value) : "";
  };

  

  const defaultOptions = (isEditiing, optionsSelected) => { //isEditing: bol options=[]array
    if (isEditiing) {
      return optionsSelected;
    } 
    return []
  };


  return (
    <div className={className}>
      <Select
        defaultValue={defaultOptions(editingEvent, editingOptions)}
        onChange={(value) => onChange(value)}
        options={options}
        isMulti
        value={defaultValue(options, value)}
      />
    </div>
  );
};

export default CustomSelect;
